module.exports = ".qualification-record{background-color:#f9f9f9;border-radius:.5rem}"